import isNil from 'lodash/isNil';
import { FormModelData } from '../components/form/form.model';
import { AnyFormControlModel } from '../dynamic-form-components/shared-models/any-form-control.model';
import { dateToString } from './date-to-string.helper';
import { flattenDeep } from './flatten-deep.helper';
import { isModelLoggable } from './is-model-loggable.helper';

export const buildCustomModel = (formModel: AnyFormControlModel[]): FormModelData[] => {
  return flattenDeep(
    formModel.map(inputModel => {
      if (isModelLoggable(inputModel)) {
        if (inputModel.groups) {
          return {
            id:     inputModel.id,
            groups: inputModel.groups.map(groupModel => buildCustomModel(groupModel.group))
          };
        }

        if (inputModel.group) {
          return buildCustomModel(inputModel.group);
        }

        if (!isNil(inputModel.value)) {
          return {
            id:   inputModel.id,
            type: inputModel.type,
            get value() {
              return dateToString(inputModel.value);
            },
            set value(value) {
              inputModel.value = value;
            }
          };
        }
      }
    })
  )
    .filter(el => !!el);
};
